exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vue-box[data-v-2cbf4fe7]{width:300px;height:150px;background-color:#174ab8;padding:5px;color:#fff;display:inline-block;-webkit-box-shadow:0 2px 45px 0 #b0b0b0;box-shadow:0 2px 45px 0 #b0b0b0;position:absolute;top:470px;left:200px}.title[data-v-2cbf4fe7]{color:#fff}.content[data-v-2cbf4fe7]{font-size:10px}.frame[data-v-2cbf4fe7]{border:1px solid #fff;height:100%}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-2cbf4fe7","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/coverage/box/Box.vue
// module id = 92
// module chunks = 0